/**
 * 设置图表
 * @param {any} pen 
 * @param {any} param 
 */
export default function () {
    console.log('初始化eharts')
    const DPC = this.proc.make('DPC');

    const that = this;

    const dateType = {
        "date": 0,
        "month": 1,
        "year": 2
    }

    const createChartData = async function (pen, timeType) {

        let statisticsData = await DPC.bindTypeStatistics();

        /**
         * @type {Array}
         */
        let statisticsID = pen.statisticsID;

        let statisticsTypes = statisticsData.find(item => item.id == statisticsID);

        if (!statisticsTypes) return;
        let chartsData = statisticsTypes.statisticsData;

        if (chartsData) {
            let optoins = pen.echarts.option || {
                xAxis: {
                    type: "category",
                    data: [],
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        data: [],
                        type: "line",
                    },
                ],
            }


            let dateList = new Map(), monthList = new Map(), yearList = new Map();

            for (let i = 0, len = chartsData.length; i < len; i++) {
                let chart = chartsData[i];
                let month = new Date(chart.Date).getMonth() + 1;
                if (!monthList.has(month)) {
                    monthList.set(month, [])
                }
                monthList.get(month).push(chart)

                let date = new Date(chart.Date).getDate();
                if (!dateList.has(date)) {
                    dateList.set(date, [])
                }
                dateList.get(date).push(chart)
                let year = new Date(chart.Date).getFullYear();
                if (!yearList.has(year)) {
                    yearList.set(year, [])
                }
                yearList.get(year).push(chart)
            }

            let xAxisData = null;
            if(Array.isArray(optoins.xAxis)){
                optoins.xAxis.forEach(item=>{
                    item.data = []
                })
                xAxisData = optoins.xAxis[0].data
            }else{
                xAxisData = optoins.xAxis.data = []
            }
            
            optoins.series[0].data = [];

            if (timeType == dateType.date) {

                dateList.forEach((item, key) => {
                    optoins.series[0].data.push(item[item.length - 1].Values)
                    xAxisData && xAxisData.push(key + '日')
                })
            } else if (timeType == dateType.month) {
                monthList.forEach((item, key) => {
                    let sun = item.reduce((a, b) => {
                        a.Values = Number(a.Values || 0) + Number(b.Values || 0)
                        return a
                    })
                    optoins.series[0].data.push(sun.Values)
                    xAxisData && xAxisData.push(key + '月')
                })
            } else if (timeType == dateType.year) {
                yearList.forEach((item, key) => {
                    let sun = item.reduce((a, b) => {
                        a.Values = Number(a.Values || 0) + Number(b.Values || 0)
                        return a
                    })
                    optoins.series[0].data.push(sun.Values)
                    xAxisData && xAxisData.push(key + '年')
                })
            }

            that.stageCanvas.setValue({
                id: pen.id,
                echarts: { option: optoins }
            })
            console.log('dateList', dateList)
            console.log('monthList', monthList)
            console.log('yearList', yearList)

        }
    }



    //周统计
    globalThis.createChartsWeek = (pen) => {
        createChartData(pen, dateType.date)
    }

    globalThis.createChartsMonth = (pen) => {
        createChartData(pen, dateType.month)
    }

    globalThis.createChartsYear = (pen) => {
        createChartData(pen, dateType.year)
    }
    // 设置全局函数名
    this.globalFunctions = ['createChartsWeek', 'createChartsMonth', 'createChartsYear']
}